import React, { Component } from 'react';

export default class HeartBreak extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M45.148,13.855c2.537,-1.98 6.066,-3.63 10.782,-3.63c16.549,0 21.317,18.074 17.372,30.009c-4.486,13.572 -12.254,16.203 -23.321,23.046c-3.433,2.122 -5.467,3.765 -6.9,4.868l5.578,-25.643l-10.035,-4.101l6.524,-24.549Zm-9.525,53.292c-1.327,-1.016 -3.09,-2.313 -5.604,-3.867c-11.067,-6.843 -18.835,-9.474 -23.321,-23.046c-3.945,-11.935 0.823,-30.009 17.372,-30.009c6.148,0 10.279,2.805 12.824,5.488l-7.212,27.139l10.309,4.213l-4.368,20.082Z"/>
              </g>
            </svg>
        )
    }
}
